// App
export const CHANGE_USER = 'CHANGE_USER'
export const CHANGE_PICTURE = 'CHANGE_PICTURE'
export const CHANGE_ROLES = 'CHANGE_ROLES'

//Loading States
export const APP_IS_LOADING = "APP_IS_LOADING";
export const APP_IS_READY = "APP_IS_READY";
